const CLAIM_YOUR_LISTING_COOKIES = {
  HAS_CLOSED_MODAL: 'ZRM_hasClosedClaimYourListingsModal',
  HAS_CLOSED_CLAIM_BANNER: 'ZRM_hasClosedClaimYourListingsBanner',
  HAS_CLOSED_UPGRADE_BANNER: 'ZRM_hasClosedUpgradeToAdPackageBanner',
  HAS_CLOSED_CLAIM_MORE_BANNER: 'ZRM_hasClosedClaimMoreListingsBanner',
  HAS_CLOSED_CLAIM_MORE_MODAL: 'ZRM_hasClosedClaimMoreListingsModal',
  EXPIRATION: 400, // max expiration date
};

const SPOTLIGHT_LISTINGS_COOKIES = {
  HAS_CLOSED_SPOTLIGHT_LISTINGS_MODAL: 'ZRM_hasClosedSpotlightListingsModal',
  EXPIRATION: 400, // max expiration date
};

export { CLAIM_YOUR_LISTING_COOKIES, SPOTLIGHT_LISTINGS_COOKIES };
